import { Component, OnInit } from "@angular/core";
import { OrcamentoPrintService } from "./orcamento-print.service";
import { ActivatedRoute } from "@angular/router";
import { Router } from '@angular/router';
import { PoModule } from "@po-ui/ng-components";
import { FormsModule } from "@angular/forms";


@Component({
  selector: "app-orcamento-print",
  templateUrl: "./orcamento-print.component.html",
  styleUrls: ["./orcamento-print.component.css"],
  standalone: false,
})

export class OrcamentoPrintComponent implements OnInit {

  codigo: string
  pedido: string;
  nomeCliente: string;
  email: string;
  endereco: string;
  cidade: string;
  fone: string;
  cnpj: string;
  contato: string;
  bairro: string;
  cep: string;
  ie: string;
  condPag: string;
  
  vendedor: string;
  obs: string;
  data: string;

  totalLiq: number;
  sTotalLiq: string;
  frete: string;
  icms: number;
  sIcms: string;
  totalBru: number;
  sTotalBru: string;
  ipi: number;
  desconto: number;
  msgObs: string;
  isPecas: boolean;

  itens: Array<any>;

  constructor(private OrcamentoPrintService: OrcamentoPrintService, private route: ActivatedRoute, private router: Router, ) {
    this.route.params.subscribe(
      (params) => (this.pedido = params["id"], this.codigo = params["cgc"])
    );
  }

  ngOnInit() {
   
    this.isPecas = sessionStorage.getItem("Segmento") === "PECAS";

   
    this.carregaCabecalho();
  }

  print() {
    window.print();
  }

  carregaCabecalho() {

    if(this.isPecas){
      this.msgObs = " Obs.: Aguardar retorno do departamento comercial para que o mesmo possa confirmar a disponibilidade dos itens inclusos e condições de pagamento. "
    }else{
      this.msgObs  = " Coletas somente 24 horas após o envio da ordem de coleta.." ;
      this.msgObs += " Entrada de caminhões para coletas de segunda-feira a quinta-feira até as 16:00.. Entrada de caminhões para coletas nas sexta-feiras até as 15:00.";
    }
    



    this.OrcamentoPrintService.getCabOrcamento(
      parseInt(this.pedido)
    ).subscribe((CabOrcamento) => {
      let dataB = new Date(CabOrcamento.emissao.replace('Z',''));
      
    
      this.data = dataB.getDate() + "/" + (dataB.getMonth() + 1) + "/" + dataB.getFullYear()
      this.frete = this.formatReal(CabOrcamento.frete);
     // this.totalLiq = CabOrcamento.valorTotal;
     // this.sTotalLiq = this.formatReal(CabOrcamento.valorTotal);
      this.obs = CabOrcamento.observacao;


      this.OrcamentoPrintService.getVendedor(
        CabOrcamento.vendedor
      ).subscribe((Vendedor) => {
        this.vendedor = Vendedor.codigo + ' - ' + Vendedor.nome;
      });

      this.OrcamentoPrintService.getItensOrcamento(parseInt(this.pedido)).subscribe((Itens) => {
        this.itens = Itens;
        this.ipi = 0;
        this.icms = 0;
        this.totalLiq = 0;
        this.desconto = 0;
        for (let index = 0; index < this.itens.length; index++) {
          this.ipi += this.itens[index].ipi;
          this.icms += this.itens[index].icms;
          this.totalLiq += (this.itens[index].precoImposto * this.itens[index].quantidade);
          this.desconto += this.itens[index].valorDesconto;

        }
        this.sTotalLiq = this.formatReal((this.totalLiq));  
        this.totalBru = (this.totalLiq -this.desconto) + this.ipi //CabOrcamento.valorTotal  //this.totalLiq //+ this.ipi;
        this.sTotalBru = this.formatReal(this.totalBru);
        this.sIcms = this.formatReal(this.icms);
      });

      this.OrcamentoPrintService.getCondPG(
        CabOrcamento.condPagamento
      ).subscribe((CondPG) => {
        this.condPag = CondPG.codigo + ' - ' + CondPG.nome
      })

      let segmto = sessionStorage.getItem('Segmento')
      let cgc = sessionStorage.getItem('cgc')

      this.OrcamentoPrintService.getDadosClientes(cgc, segmto).subscribe(
        (cli) => {
          if (cli.length > 0){
            let Cliente = cli[0]
            
            if (this.router.url.indexOf("orcamentocliente")  != -1 ) {
              this.validaAcesso(Cliente.codigo);
            }
            this.nomeCliente = Cliente.codigo + '-' + Cliente.nome;
            if (Cliente.tipo === "F") {
              this.cnpj = this.mascaraCpf(Cliente.cgc);
            } else {
              this.cnpj = this.mascaraCnpj(Cliente.cgc);
            }
            this.endereco = Cliente.endereco.trim() + ',' + Cliente.numero;
            this.bairro = Cliente.bairro.trim();
            this.cidade = Cliente.municipio.trim() + '/' + Cliente.uf;
            this.email = Cliente.email.trim();
            this.fone = "(" + Cliente.ddd.trim() + ") " + Cliente.telefone.trim();
            this.ie = Cliente.inscr.trim();
            this.cep = Cliente.cep.trim();
            this.contato = Cliente.contato;
          }
        }
      );
    });
  }


  mascaraCpf(valor) {
    return valor.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4");
  } mascaraCnpj(valor) {
    return valor.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "\$1.\$2.\$3\/\$4\-\$5");
  }

  formatReal(int) {
    return "R$ " + int.toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+\,)/g, "$1.");
  }

  formatValor(int) {
    return  int.toFixed(2).replace('.', ',').replace(/(\d)(?=(\d{3})+\,)/g, "$1.");
  }

  inteiro(numero) {
    return parseInt(numero)
  }

  validaAcesso(codigo) {
    if (this.codigo !== codigo) {
      this.router.navigate(["/"], {});
    }
  }

}
